/* ============================================================
   URINKING · Voraussichtliches Lieferdatum  [02.10.2026]
   Gehoert zu snippets/uk-lieferdatum.liquid.

   REGELN (von Kinan, 02.10.2026):
   - Versand jeden Tag bis 20 Uhr (deutsche Zeit), auch am Wochenende.
     Bezahlt wird per Echtzeitueberweisung - das Geld ist sofort da.
   - Zustellung 1-2 Werktage nach dem Versand.

   WERKTAGE DER POST sind Montag bis Samstag ohne bundesweite
   Feiertage. Liegt der Versandtag auf einem Sonntag oder Feiertag,
   nimmt die Post die Sendung erst am naechsten Werktag an - gezaehlt
   wird dann ab dort. Laendereigene Feiertage (z. B. Fronleichnam)
   sind bewusst nicht drin: Sie gelten nicht ueberall, und ein
   Zustelltag zu frueh ist schlechter als ein Tag Puffer, den es
   nicht gibt - deshalb heisst es "voraussichtlich".

   Die Schublade wird nach jeder Aenderung per innerHTML neu gebaut.
   Ein MutationObserver fuellt neu eingesetzte Zeilen sofort.
   ============================================================ */
(function () {
  if (window.ukLieferdatum) { return; }
  window.ukLieferdatum = true;

  var SCHLUSS = 20; // Uhr, Versandschluss

  // Uhrzeit und Datum in Berlin, egal wo das Geraet steht.
  function berlinJetzt() {
    var teile = {};
    new Intl.DateTimeFormat('de-DE', {
      timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (t) { teile[t.type] = parseInt(t.value, 10); });
    return teile;
  }

  function ostersonntag(j) {
    var a = j % 19, b = Math.floor(j / 100), c = j % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var monat = Math.floor((h + l - 7 * m + 114) / 31), tag = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(j, monat - 1, tag));
  }

  var feiertagCache = {};
  function feiertage(j) {
    if (feiertagCache[j]) { return feiertagCache[j]; }
    var o = ostersonntag(j).getTime(), tag = 864e5;
    var liste = [
      Date.UTC(j, 0, 1), o - 2 * tag, o + tag, Date.UTC(j, 4, 1), o + 39 * tag,
      o + 50 * tag, Date.UTC(j, 9, 3), Date.UTC(j, 11, 25), Date.UTC(j, 11, 26)
    ];
    var menge = {};
    liste.forEach(function (t) { menge[new Date(t).toISOString().slice(0, 10)] = true; });
    return (feiertagCache[j] = menge);
  }

  // Tage als UTC-Mitternacht - keine Sommerzeit-Spruenge beim Weiterzaehlen.
  function istWerktag(d) {
    return d.getUTCDay() !== 0 && !feiertage(d.getUTCFullYear())[d.toISOString().slice(0, 10)];
  }
  function plusTag(d) { return new Date(d.getTime() + 864e5); }
  function plusWerktage(d, n) {
    while (n > 0) { d = plusTag(d); if (istWerktag(d)) { n--; } }
    return d;
  }

  var WT = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  function kurz(d) {
    return WT[d.getUTCDay()] + ' ' + ('0' + d.getUTCDate()).slice(-2) + '.' + ('0' + (d.getUTCMonth() + 1)).slice(-2) + '.';
  }

  function rechnen() {
    var b = berlinJetzt();
    var heute = new Date(Date.UTC(b.year, b.month - 1, b.day));
    var vorSchluss = b.hour < SCHLUSS;
    var versand = vorSchluss ? heute : plusTag(heute);
    var annahme = versand;
    while (!istWerktag(annahme)) { annahme = plusTag(annahme); }
    var von = plusWerktage(annahme, 1), bis = plusWerktage(annahme, 2);

    var rest = '';
    if (vorSchluss) {
      var min = (SCHLUSS - b.hour) * 60 - b.minute - (b.second > 0 ? 1 : 0);
      if (min < 0) { min = 0; }
      var std = Math.floor(min / 60), m = min % 60;
      rest = std > 0 ? std + ' Std. ' + m + ' Min.' : m + ' Min.';
    }
    return { von: kurz(von), bis: kurz(bis), rest: rest, morgen: !vorSchluss };
  }

  function fuellen(el, r) {
    var zeile = el.querySelector('.uk-liefer__zeile');
    var frist = el.querySelector('.uk-liefer__frist');
    if (!zeile || !frist) { return; }
    // Kurz gehalten: Am Telefon (390 px) muss jede Zeile in eine Zeile
    // passen, sonst zerfaellt der Block in vier halbe. [02.10.2026]
    zeile.innerHTML = '🚚 Voraussichtlich da: <strong>' + r.von + '–' + r.bis + '</strong>';
    frist.innerHTML = r.rest
      ? 'Versand: heute, wenn du in <strong>' + r.rest + '</strong> bestellst'
      : 'Versand: morgen';
    el.setAttribute('data-uk-liefer-fertig', '');
  }

  function alle() {
    var r = rechnen();
    Array.prototype.forEach.call(document.querySelectorAll('[data-uk-liefer]'), function (el) { fuellen(el, r); });
  }

  function start() {
    alle();
    // Minutengenau reicht; Sekunden ticken zu lassen lenkt nur ab.
    setInterval(alle, 30000);
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (document.querySelector('[data-uk-liefer]:not([data-uk-liefer-fertig])')) { alle(); }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
